import { createContext, FC, ReactNode, useContext, useMemo } from "react";

export interface QuickSearchContextValue {
  query: string;
}

const QuickSearchContext = createContext<QuickSearchContextValue>({ query: "" });

interface QuickSearchProviderProps {
  query: string;
  children: ReactNode;
}

export const QuickSearchProvider: FC<QuickSearchProviderProps> = ({ query, children }) => {
  const value = useMemo<QuickSearchContextValue>(() => ({ query }), [query]);
  return <QuickSearchContext.Provider value={value}>{children}</QuickSearchContext.Provider>;
};

export const useQuickSearchContext = (): QuickSearchContextValue => useContext(QuickSearchContext);
